import { Card, CardTitle, CardText } from 'react-md'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
  getSales,
  getSalePage,
  getSaleRowsPerPage,
  getSaleCount
} from 'redux/reducers'
import config from 'config'
import * as actions from 'redux/actions'
import * as routes from 'routes'

import SaleList from './SaleList'
import SaleListActions from './SaleListActions'

class Sales extends Component {
  constructor (props) {
    super(props)

    this.refresh = this.refresh.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handlePagination = this.handlePagination.bind(this)
    this.handleRefreshClick = this.handleRefreshClick.bind(this)
  }

  componentWillMount () {
    const {
      loadSales,
      salePageChange,
      saleRowsPerPageChange
    } = this.props

    // initializes pagination on the first page
    salePageChange(1)
    saleRowsPerPageChange(config.pagination.defaultRowsPerPage)

    // refresh sales from the current page
    loadSales(0, config.pagination.defaultRowsPerPage)
  }

  refresh () {
    const { salePage, saleRowsPerPage } = this.props
    const start = (salePage - 1) * saleRowsPerPage
    this.handlePagination(start, saleRowsPerPage)
  }

  async handlePagination (start, rowsPerPage) {
    const {
      loadSales,
      salePageChange,
      saleRowsPerPageChange
    } = this.props

    // refresh sales from the next page
    await loadSales(start, rowsPerPage)

    // updates pagination
    salePageChange(Math.floor(start / rowsPerPage) + 1)
    saleRowsPerPageChange(rowsPerPage)
  }

  handleRefreshClick () {
    this.refresh()
  }

  handleClick (id) {
    const { history } = this.props
    const parts = id.split('-')
    const artworkId = parts[1]
    history.push(routes.artwork(artworkId))
  }

  render () {
    const { sales, salePage, saleRowsPerPage, saleCount } = this.props

    const start = (salePage - 1) * saleRowsPerPage
    const end = start + saleRowsPerPage

    const title = 'My Sales'

    if (!saleCount) {
      return (
        <Card>
          <CardTitle title={title} />
          <CardText>No sales yet.</CardText>
        </Card>
      )
    }

    return (
      <div>

        <Card tableCard>

          <SaleListActions
            title={title}
            onRefreshClick={this.handleRefreshClick}
          />

          <SaleList
            data={sales.slice(start, end)}
            page={salePage}
            rowsPerPage={saleRowsPerPage}
            count={saleCount}
            handleClick={this.handleClick}
            handlePagination={this.handlePagination}
          />

        </Card>

      </div>
    )
  }
}

Sales.propTypes = {
  sales: PropTypes.array.isRequired
}

const mapStateToProps = (state) => ({
  sales: getSales(state),
  salePage: getSalePage(state),
  saleRowsPerPage: getSaleRowsPerPage(state),
  saleCount: getSaleCount(state)
})

export default connect(mapStateToProps, actions)(Sales)



// WEBPACK FOOTER //
// ./src/containers/Sales/index.js